import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { QuoteMarkAsSentPage } from 'src/app/modals/quote-mark-as-sent/quote-mark-as-sent.page';

const routes: Routes = [
    {
        path: '',
        component: QuoteMarkAsSentPage
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        FontAwesomeModule,
        RouterModule.forChild(routes)
    ],
    declarations: [QuoteMarkAsSentPage]
})

export class QuoteMarkAsSentPageModule { }
